const translations = {
  "en": {
    "Check your email": "Check your email",
    "Continue with Email": "Continue with Email",
    "Enter your email": "Enter your email",
    "Invalid verification code": "Invalid verification code",
    "Log in or create your account.": "Log in or create your account.",
    "Meet your ": "Meet your ",
    "money person": "money person",
    "or continue with": "or continue with",
    "We sent a 6-digit code to": "We sent a 6-digit code to"
  },
  "zh-tw": {
    "Check your email": "檢查你的電子郵件",
    "Continue with Email": "繼續使用電子郵件",
    "Enter your email": "輸入你的電子郵件",
    "Invalid verification code": "驗證碼錯誤",
    "Log in or create your account.": "登入或建立你的帳戶。",
    "Meet your ": "認識你的",
    "money person": "私人理財官",
    "or continue with": "或繼續使用",
    "We sent a 6-digit code to": "我們已傳送一組 6 位數驗證碼至"
  }
};

export default translations;
